import styled from "styled-components";
import { THEME } from "../../styles/theme";

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  > img {
    width: 8rem;
    margin: auto;
  }
  > form {
    height: 40%;
    background-color: ${THEME.palette.background.default};
    padding: 2rem 2rem 1rem 2rem;
    border-radius: 2rem 2rem 0 0;
    display: flex;
    flex-direction: column;
  }
`;
